import { TabProxy } from "encampy";

export async function automateTierIIManagerLogin(
  tab: TabProxy,
  username: string,
  password: string
): Promise<void> {
  // Wait for the login page to load
  await tab.waitForElement("input#UserName", { timeout: 10000 });

  // Type in username and password, submit form after password
  await tab.type("input#UserName", username);
  await tab.type("input#Password", password, { submit: true });

  // Wait for navigation to complete after login
  await tab.waitForNavigation({ timeout: 10000 });
}
